"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const QRCodeReact = require("qrcode.react");
/**Muestra un codigo QR */
class QRCode extends React.PureComponent {
    render() {
        const size = this.props.size || 128;
        return (React.createElement("div", { style: { padding: size / 4 + "px" } },
            React.createElement(QRCodeReact, { value: this.props.value, size: size, level: "L" })));
    }
}
exports.QRCode = QRCode;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/qr/view.js
// module id = 2251
// module chunks = 0